import React from 'react';

import dotSeparateNumber from '../utils/dotSeparateNumber';
import { formatCurrency } from '../utils/format';

function CotizadorHero({ request, clientName, clientDNI }) {
  return (
    <>
      <p className="text-uppercase fw-semibold mb-2" style={{fontSize: '0.75rem', color: 'var(--color-text-muted)', letterSpacing: '0.1em'}}>
        Inicio / Preaprobado
      </p>
      <h1 className="fw-bold mb-1" style={{fontSize: 'clamp(2rem, 3vw, 2.75rem)', color: 'var(--color-text-dark)'}}>
        Resultados de tu Consulta
      </h1>
          <p className="mb-4" style={{color: 'var(--color-text-muted)', fontSize: '0.95rem'}}>
            Este es tu monto máximo disponible
          </p>
      <section className="rounded-3 d-flex flex-column flex-md-row gap-0 align-items-stretch mb-4 bg-white shadow overflow-hidden" >
        <div className="flex-grow-1 d-flex align-items-center p-3 p-md-4">
          <div className="d-flex flex-column gap-2">
              <div className="d-flex gap-2 align-items-baseline">
                <span className="fw-semibold" style={{color: 'var(--color-text-dark)', fontSize: '0.9rem'}}>Nombre:</span>
                <span style={{color: 'var(--color-text-dark)', fontSize: '0.9rem'}}>{clientName?.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</span>
              </div>
              <div className="d-flex gap-2 align-items-baseline">
                <span className="fw-semibold" style={{color: 'var(--color-text-dark)', fontSize: '0.9rem'}}>DNI:</span>
                <span style={{color: 'var(--color-text-dark)', fontSize: '0.9rem'}}>{dotSeparateNumber(clientDNI)}</span>
              </div>
          </div>
        </div>
        <div className="text-white px-4 py-3" style={{background: 'var(--color-accent)'}}>
          <span className="d-block mb-0" style={{fontSize: '0.8rem', letterSpacing: '0.05em'}}>
            Preaprobado de:
          </span>
          <strong className="d-block fw-bold" style={{fontSize: '2rem'}}>
            {formatCurrency(request?.maxAmount)}
          </strong>
        </div>
      </section>
    </>
  );
}

export default CotizadorHero;
